import LoadingScreen from 'app/components/LoadingScreen'
import DodoablesList from 'app/dodoables/list/Index'
import useDodoableCollectionQuery from 'generated/api/dodoables/useDodoableCollectionQuery'

export default ({ dodoableId }) => {
  const { isPending, data: { dodoables } = {} } = useDodoableCollectionQuery({
    path: 'api/dodoables'
  })

  if (isPending) return <LoadingScreen />
  return <DodoablesList dodoables={dodoables} />
}
